import { BrowsePageOutput } from 'js/model/rainbow/browse-page/BrowsePageOutput';
import { ChannelOutput } from 'js/model/rainbow/content/ChannelOutput';

/**
 * Enriches the `browsePageOutput` object by ensuring that the `specification.location`
 * property is set, and prepends the `channelLocation` to the aggregations list if needed.
 *
 * This function is safe to call multiple times. If the `location` is already present,
 * it leaves the existing value untouched.
 *
 * @param browsePageOutput - The original API response object.
 * @param channelLocation - The location object to inject if missing.
 *
 * @returns A new `browsePageOutput` object with `specification.location` guaranteed and
 *          `channelLocation` added to `aggregations.locations` if not already present.
 */
export const enrichBrowsePageOutputWithLocationIfMissing = (
  browsePageOutput: BrowsePageOutput,
  channelLocation: ChannelOutput['country']
) => {
  const enrichedBrowsePageOutput = { ...browsePageOutput };

  if (enrichedBrowsePageOutput.specification.location) {
    return enrichedBrowsePageOutput;
  }

  enrichedBrowsePageOutput.specification = {
    ...enrichedBrowsePageOutput.specification,
    location: {
      tree: channelLocation,
    },
  };

  enrichedBrowsePageOutput.aggregations = {
    ...enrichedBrowsePageOutput.aggregations,
    locations: [
      {
        ...channelLocation,
        count: 0,
      },
      ...enrichedBrowsePageOutput.aggregations.locations,
    ],
  };

  return enrichedBrowsePageOutput;
};
